import { environment } from '../environments/environment';
import { AfterViewInit, Component, OnInit, ViewContainerRef } from '@angular/core';
import { CookieService } from 'ng2-cookies';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { ToastsManager } from 'ng2-toastr';
import { UserModel } from './models/user.model';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  public user: UserModel = new UserModel();
  public adminPanelUrl: string;
  public featureToggles: any;
  public appVersion = environment.version;

  constructor(
    private cookieService: CookieService,
    private router: Router,
    private authService: AuthService,
    private dateAdapter: DateAdapter<Date>,
    public toastr: ToastsManager,
    public translate: TranslateService,
    vRef: ViewContainerRef
  ) {
    this.toastr.setRootViewContainerRef(vRef);
    this.adminPanelUrl = `${environment.ADMIN_PANEL_URL}`;
    this.manageLanguageSettings();
  }

  ngOnInit() {
    this.authService.userModelChange.subscribe(userModel => {
      this.featureToggles = this.authService.featureTogglesFlags;
      if (!userModel.hasOwnProperty('username')) {
        this.user = new UserModel();
      } else {
        this.user = userModel;
      }
    });
  }

  ngAfterViewInit() {
    console.log('AppComponent::ngAfterViewInit');
  }

  logout(): void {
    this.router.navigate(['sign-in']).then(() => this.authService.logout());
  }

  checkIfLoggedIn(): boolean {
    return !!this.authService.token;
  }

  getFullLanguageName(language: string): string {
    return language === 'pl' ? 'Polski' : 'English';
  }

  manageLanguageSettings() {
    this.translate.addLangs(['en', 'pl']);
    this.translate.setDefaultLang('pl');
    const preferedLanguage = this.cookieService.get('language');
    if (preferedLanguage) {
      this.translate.use(preferedLanguage.match(/en|pl/) ? preferedLanguage : 'pl');
    } else {
      const browserLang = this.translate.getBrowserLang();
      this.translate.use(browserLang.match(/en|pl/) ? browserLang : 'pl');
    }
    this.translate.onLangChange.subscribe(change => {
      if (change.lang.match(/en|pl/)) {
        this.cookieService.set('language', change.lang);
        this.dateAdapter.setLocale(this.translate.currentLang);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts